window.RebuyCustom = {
  getVariantImageForColor: function (product, color) {
    const variant = this.getVariant(color, product);
    return window.Rebuy.util.itemImage(product, variant, "400x400");
  },
  getVariant: function (value, product) {
    const colorIndex = product.options.findIndex((option) => {
      return option.name === "Color";
    });

    const variantMatch = product.variants.find((variant) => {
      const color = variant[`option${colorIndex + 1}`];
      return color === value;
    });

    return variantMatch;
  },
};
